import React from "react";
import Iconify from "../../../components/iconify";
import { Button, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { setDialog } from "../../../features/dialog/dialogSlice";
import { useGetSitesQuery } from "../../../features/sites/sitesApiSlice";

export default function NoSitesYet() {
  const dispatch = useDispatch();
  const { data: sites, isLoading } = useGetSitesQuery();

  const handleOpenSitesForm = () => {
    dispatch(setDialog({ title: "Neuen Standort erstellen", type: "CREATE" }));
  };

  if (!sites && !isLoading) {
    return (
      <div style={{ textAlign: "center" }}>
        <div>
          <Iconify icon={"fa-solid:torii-gate"} width={125} height={125} />
        </div>
        <Typography variant="h4">
          Um zu beginnen legen Sie bitte zuerst einen Standort an.
        </Typography>
        <div>
          <Button
            variant="contained"
            color="secondary"
            sx={{
              mt: 2,
              mb: 3,
              fontSize: "125%",
            }}
            onClick={() => handleOpenSitesForm()}
          >
            Neuer Standort
          </Button>
        </div>
      </div>
    );
  } else return null;
}
